import { plural } from "@magnit/core/src/utilities/plural";

export const pluralRatingCount = (count: number) =>
  plural(count, "отзыв", "отзыва", "отзывов");
export const pluralScoreCount = (count: number) =>
  plural(count, "оценка", "оценки", "оценок");
